import { render, staticRenderFns } from "./IFProfitAndLoss.vue?vue&type=template&id=4062f008"
import script from "./IFProfitAndLoss.vue?vue&type=script&lang=js"
export * from "./IFProfitAndLoss.vue?vue&type=script&lang=js"
import style0 from "./IFProfitAndLoss.vue?vue&type=style&index=0&id=4062f008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports